import { Button, Step, StepContent, StepLabel, Stepper, } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import { Field, Form, Formik } from 'formik';
import { CheckboxWithLabel } from 'formik-material-ui';
import React, { useEffect, useState } from 'react';
import { holidayInitialValues } from '../../../../commons/assets/InitialValues';
import { CustomTextField } from '../../../../commons/CustomTextField';
import { EditableTextField } from '../../../../commons/EditableTextField';
import { SnackbarComponent } from '../../../../commons/SnackbarComponent';
import { holidayValidationSchema } from '../../../../commons/validation/HolidayValidation';
import { Title } from '../../SchedulerMainView.Styles';
import { ButtonWrapper, FormWrapper, Wrapper, } from './HolidayConfigurator.Styles';
import { TextGroupWrapper } from './Schedule/Schedule.Styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { ConfigWrapper } from '../../../SchedulerConfigurator/SchedulerConfigurator.Styles';
import { AccountSelector } from '../../../../commons/AccountSelector';
import { accounts } from '../../../../../frontend-config';
import { config_baseURL, set_config_baseURL } from '../../../../../api/utils';
export var HolidayConfigurator = function (_a) {
    var onDiscardClick = _a.onDiscardClick, onSubmit = _a.onSubmit, creating = _a.creating, addHoliday = _a.addHoliday, updateHoliday = _a.updateHoliday, deleteHoliday = _a.deleteHoliday, holiday = _a.holiday, holidays = _a.holidays, setSelectedHD = _a.setSelectedHD, onAlert = _a.onAlert, onAccountChange = _a.onAccountChange;
    var _b = useState(false), clickStatus = _b[0], setClickStatus = _b[1];
    var _c = useState(false), openSnack = _c[0], setOpenSnack = _c[1];
    var _d = useState(holiday), selectedHoliday = _d[0], setSelectedHoliday = _d[1];
    var _e = useState(false), openAlert = _e[0], setOpenAlert = _e[1];
    var _f = useState(), configAccount = _f[0], setConfigAccount = _f[1];
    var handleDiscard = function (resetForm) {
        resetForm();
        onDiscardClick();
        setSelectedHD(null);
        setClickStatus(false);
    };
    var handleSubmit = function (submitForm) {
        submitForm();
        // setOpenSnack(true);
    };
    var handleClose = function (_event, reason) {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };
    var onSend = function (values, resetForm) {
        var temp = {
            Date: values.date,
            HolidayName: values.holidayConfigName,
            RepeatAnnually: values.repeatAnnually
        };
        if (creating) {
            addHoliday(temp, function () {
                handleDiscard(resetForm);
            });
        }
        else {
            updateHoliday(temp, holiday, function () {
                handleDiscard(resetForm);
            });
        }
    };
    useEffect(function () {
        setSelectedHoliday(holiday);
        if (holiday && holiday['prjacc']) {
            setConfigAccount(accounts.find(function (a) { return a.url === holiday['prjacc'].url; }));
            set_config_baseURL(holiday['prjacc'].urll);
        }
        else {
            setConfigAccount(accounts.find(function (a) { return a.url === config_baseURL(); }));
        }
    }, [holiday]);
    var setFormValues = function (setValues) {
        var _holiday = holiday;
        if (_holiday) {
            var formHoliday = {
                holidayConfigName: _holiday.HolidayName,
                date: _holiday.Date,
                repeatAnnually: _holiday.RepeatAnnually
            };
            setValues(formHoliday);
        }
    };
    var handleAlertClose = function () {
        setOpenAlert(false);
    };
    var checkHolidayName = function (formValues) {
        var lowerCheck = formValues.holidayConfigName.toLowerCase();
        var holidayCheck = holidays.filter(function (hol) {
            return hol.HolidayName.toLowerCase() === lowerCheck;
        });
        return (holidayCheck.length === 0 ||
            (holidayCheck.length > 0 &&
                !creating &&
                formValues.holidayConfigName === (holiday === null || holiday === void 0 ? void 0 : holiday.HolidayName)));
    };
    return (React.createElement(Wrapper, null,
        React.createElement(FormWrapper, null,
            React.createElement(Formik, { initialValues: holidayInitialValues, validationSchema: holidayValidationSchema, onSubmit: function (values, _a) {
                    var setSubmitting = _a.setSubmitting, resetForm = _a.resetForm;
                    if (checkHolidayName(values)) {
                        onSend(values, resetForm);
                    }
                    else {
                        onAlert('This Holiday Name is already in use please use a new one', 'warning');
                    }
                    setSubmitting(false);
                } }, function (_a) {
                var submitForm = _a.submitForm, isSubmitting = _a.isSubmitting, resetForm = _a.resetForm, values = _a.values, setFieldValue = _a.setFieldValue, touched = _a.touched, errors = _a.errors, setValues = _a.setValues;
                return (React.createElement(Form, null,
                    useEffect(function () {
                        setTimeout(function () {
                            setFormValues(setValues);
                        }, 400);
                    }, [selectedHoliday]),
                    React.createElement(Title, { variant: 'h5', gutterBottom: true },
                        React.createElement(Field, { name: 'holidayConfigName', label: 'Holiday Name', component: EditableTextField })),
                    React.createElement(Divider, null),
                    React.createElement(ConfigWrapper, null,
                        React.createElement(AccountSelector, { initialValue: configAccount, onValueChange: function (account) {
                                if (account && account !== 'All') {
                                    setConfigAccount(account);
                                    onAccountChange(account.url);
                                    set_config_baseURL(account.url);
                                }
                            }, fullWidth: true, noAll: true, disabled: !creating })),
                    React.createElement(Stepper, { activeStep: 0, orientation: 'vertical' },
                        React.createElement(Step, { expanded: true },
                            React.createElement(StepLabel, null, "Holiday Schedule"),
                            React.createElement(StepContent, null,
                                React.createElement(TextGroupWrapper, null,
                                    React.createElement(CustomTextField, { name: 'date', label: 'Date', type: 'date', fullWidth: true }),
                                    React.createElement(Field, { component: CheckboxWithLabel, type: 'checkbox', name: 'repeatAnnually', Label: {
                                            label: 'Repeat Annually',
                                            labelPlacement: 'end'
                                        } })))),
                        React.createElement(Step, { expanded: true },
                            React.createElement(StepContent, null,
                                React.createElement(ButtonWrapper, null,
                                    React.createElement(Button, { variant: 'contained', color: 'primary', disabled: isSubmitting, onClick: function () {
                                            handleSubmit(submitForm);
                                        } }, creating === true ? 'Create' : 'Update'),
                                    !creating && (React.createElement(Button, { variant: 'contained', color: 'primary', onClick: function () {
                                            setOpenAlert(true);
                                            // handleDiscard(resetForm);
                                        } }, "Delete")),
                                    React.createElement(Button, { variant: 'contained', color: 'primary', onClick: function () { return handleDiscard(resetForm); } }, "Discard")),
                                React.createElement(SnackbarComponent, { anchorOrigin: { vertical: 'top', horizontal: 'center' }, open: openSnack, autoHideDuration: 3000, onAlertClose: handleClose, alertMessage: isSubmitting || clickStatus
                                        ? 'Holiday Saved!'
                                        : 'Holiday Save Failed!', severity: isSubmitting || clickStatus ? 'success' : 'error' }))))));
            })),
        React.createElement(Dialog, { open: openAlert, onClose: function () { return handleAlertClose(); }, "aria-labelledby": 'alert-delete', "aria-describedby": 'alert-dialog-description' },
            React.createElement(DialogTitle, { id: 'alert-delete' }, "Delete " + (holiday === null || holiday === void 0 ? void 0 : holiday.HolidayName) + "?"),
            React.createElement(DialogContent, null,
                React.createElement(DialogContentText, { id: 'alert-dialog-description' }, "Are you sure you want to delete this holiday?")),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: function () { return handleAlertClose(); }, color: 'primary' }, "Disagree"),
                React.createElement(Button, { onClick: function () {
                        deleteHoliday(holiday === null || holiday === void 0 ? void 0 : holiday.id, function () {
                            handleDiscard(function () { });
                        });
                    }, color: 'primary', autoFocus: true }, "Agree")))));
};
HolidayConfigurator.defaultProps = {
    // bla: 'test',
    title: 'Create Schedule'
};
//# sourceMappingURL=HolidayConfigurator.js.map